
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import TruckModule from "@/store/modules/truck";
import notifications from "@/lib/notifications";
import { TruckListFilters } from "@/models/api/trucks/getTrucks";
import { AccountModule, SystemModule } from "@/store/modules";

const truckModuleState = getModule(TruckModule);
const systemModuleState = getModule(SystemModule);
const accountModuleState = getModule(AccountModule);

@Component
export default class TruckFilters extends Vue {
  localFilters: TruckListFilters = null;

  get filters() {
    return truckModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));

    if (systemModuleState.facilities && systemModuleState.facilities.length == 1)
    {
      this.localFilters.facilities = [];
      this.localFilters.facilities[0] = systemModuleState.facilities[0].facilityCode;
    }
    else
      this.localFilters.facilities =
        accountModuleState.truckFilterFacilityCodeUserSettings 
          ? accountModuleState.truckFilterFacilityCodeUserSettings
          : null;

    truckModuleState.setFilters(this.localFilters);
  }

  async submit() {
    truckModuleState.setFilters(this.localFilters);
    truckModuleState.setLoading(true);
    try {
      accountModuleState.updateUserSettings({
        settingName: "truckFilterFacilityCode",
        values: this.localFilters.facilities
      });
      await truckModuleState.getTrucks({
        pageNumber: 1,
        pageSize: truckModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Trucks", "Failed to load trucks", ex);
    }

    truckModuleState.setLoading(false);
  }
}
